import { forwardRef, useImperativeHandle, useState } from 'react';
import { ToastContainer } from 'react-bootstrap';
import Toast from 'react-bootstrap/Toast';
import { CheckCircle2, AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './ToastMessage.scss';

type Props = {
  onSuccess?: any,
};

// App-wide toast, rendered at the root (outside any .bd[data-theme] page wrapper), so it
// follows the global dark/light class on <html> that App.tsx toggles, not the design-system
// per-page theme. Colour is tied to --bd-accent-active (design-system/accent.ts), so it also
// follows the accent picker.
export const ToastMessage = forwardRef((props: Props, ref) => {
  const { t } = useTranslation();
  const [state, setState] = useState<any>({ show: false });

  const toggleShow = (bodyMsg: string, isError = false) => {
    setState({ show: true, body: bodyMsg, error: isError });
  }

  useImperativeHandle(ref, () => ({
    toggleShow,
  }));

  const Icon = state.error ? AlertCircle : CheckCircle2;

  return (
    <ToastContainer position="top-end" className="position-fixed toast-pos">
      <Toast
        className={`bd-toast ${state.error ? 'bd-toast-error' : 'bd-toast-success'}`}
        onClose={() => setState({ ...state, show: false })}
        show={state.show}
        delay={3500}
        autohide
      >
        <Toast.Header>
          <Icon className="bd-toast-icon" size={16} aria-hidden="true" />
          <strong className="me-auto">{state.error ? t('toast.titleError') : t('toast.titleSuccess')}</strong>
        </Toast.Header>
        <Toast.Body>{state.body}</Toast.Body>
      </Toast>
    </ToastContainer>
  )
})
